if (!customElements.get('reserve-widget')) {
    customElements.define(
      'reserve-widget',
      class ReserveWidget extends HTMLElement {
        constructor() {
          super();

          this.elements = {
            formattedExpiredDate: this.querySelector('#formatted-expired-date'),
            formattedEndDate: this.querySelector('#formatted-end-date'),
            formattedUpcomingDate: this.querySelector('#formatted-upcoming-date'),
            daysRemaining: this.querySelector('#days-remaining'),
            dayLabel: this.querySelector('#day-label'),
            percentValue: this.querySelector('#percent-value'),
            progressFill: this.querySelector('#progress-fill'),
          };

          this.today = new Date();
          this.today.setHours(0, 0, 0, 0);

          this.msPerDay = 86400000;
          this.formattedExpiredDate = null;
          this.formattedEndDate = null;
          this.formattedUpcomingDate = null;
        }

        connectedCallback() {
            this.init();
        }

        getOrdinalSuffix(n) {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }

        formatDate(date) {
            const month = date.toLocaleString('en-US', { month: 'long' }).toUpperCase();
            const day = date.getDate();
            return `${month} ${this.getOrdinalSuffix(day).toUpperCase()}`;
        }

        parseDateToLocalMidnight(str) {
            const d = new Date(str);
            d.setHours(0,0,0,0);
            return d;
        }

        calculateDaysRemainingAndElapsed() {
            const daysRemaining = Math.max(0, Math.ceil((this.endDate - this.today) / this.msPerDay));
            const daysElapsed = Math.max(0, Math.floor((this.today - this.startDate) / this.msPerDay));
            const currentPercent = Math.min(100, this.startPercent + (this.increment * daysElapsed));
            return { daysRemaining, daysElapsed, currentPercent };
        }

        prepareDates() {
            const lastDayOfPreviousMonth = new Date(this.today.getFullYear(), this.today.getMonth(), 0);
            const firstDayOfNextMonth = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);

            this.formattedEndDate = this.formatDate(this.endDate);

            if (!this.autoUpdateDate) { return; }

            this.formattedExpiredDate = this.formatDate(lastDayOfPreviousMonth);
            this.formattedUpcomingDate = this.formatDate(firstDayOfNextMonth);
        }

        updateProgress() {
            const { daysRemaining, daysElapsed, currentPercent } = this.calculateDaysRemainingAndElapsed();

            this.elements.daysRemaining && (this.elements.daysRemaining.textContent = daysRemaining);
            this.elements.dayLabel && (this.elements.dayLabel.textContent = daysRemaining > 1 ? 'days' : 'day');
            this.elements.percentValue && (this.elements.percentValue.textContent = currentPercent + '%');
            this.elements.progressFill && (this.elements.progressFill.style.width = currentPercent + '%');
        }

        updateExpiredAndUpcomingDates() {
            if (!this.autoUpdateDate) return;

            if (this.formattedExpiredDate && this.elements.formattedExpiredDate) {
                this.elements.formattedExpiredDate.textContent = this.formattedExpiredDate;
            }

            if (this.formattedUpcomingDate && this.elements.formattedUpcomingDate) {
                this.elements.formattedUpcomingDate.textContent = this.formattedUpcomingDate;
            }
        }

        updateCurrentEndDate() {
            if (this.formattedEndDate && this.elements.formattedEndDate) {
                this.elements.formattedEndDate.textContent = this.formattedEndDate;
            }
        }

        init() {
            this.prepareDates();
            this.updateProgress();
            this.updateCurrentEndDate();
            this.updateExpiredAndUpcomingDates();
        }

        get increment() {
            return parseInt(this.getAttribute('increment'));
        }

        get startPercent() {
            return parseInt(this.getAttribute('start-percent')) || 10;
        }

        get endDate() {
            const hardDate = this.getAttribute('hard-end-date') || document.querySelector('#custom-hard-end-date')?.value;
            if (hardDate) {
                return this.parseDateToLocalMidnight(hardDate);
            }
            return new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 1);
        }

        get startDate() {
            return this.parseDateToLocalMidnight(this.getAttribute('start-date'));
        }

        get autoUpdateDate() {
            return this.getAttribute('auto-update-date') === 'true';
        }
      }
    );
  }